import React from 'react';

import { useSelector } from 'react-redux';

import { ReactComponent as Empty } from '../../../components/Table/TableEmpty/empty.svg';
import { ReactComponent as EmptyDarkMode } from '../../../components/Table/TableEmpty/empty-dark-mode.svg';

const TableEmpty = () => {
  const { darkMode } = useSelector((state) => state.general);

  return (
    <div className="custom-table__empty-items-cell">
      <div className="custom-table__empty-items-default">
        <div className="custom-table__empty-items-default-content">
          <div className="custom-table__empty-items-default-icon">
            {darkMode ? <EmptyDarkMode /> : <Empty />}
          </div>
          <div className="custom-table__empty-items-default-description">
            <div>Table is empty</div>
          </div>
        </div>
      </div>
    </div>
  )
};

TableEmpty.propTypes = {

};

export default TableEmpty;
